import { render, staticRenderFns } from "./_IpDistribution.vue?vue&type=template&id=38317aba"
import script from "./_IpDistribution.vue?vue&type=script&lang=ts"
export * from "./_IpDistribution.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports